import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-campo-hora',
  standalone: true,
  imports: [],
  templateUrl: './campo-hora.component.html',
  styleUrl: './campo-hora.component.css',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CampoHoraComponent), multi: true }
  ]
})
export class CampoHoraComponent implements ControlValueAccessor {
  @Input() label = 'Horário';
  @Input() icone = './assets/icones/redesign/inputs/input-time-clock.svg';
  @Input() erro = '';
  @Input() disabled = false;

  valor = '';
  tocado = false;

  private digitos: string[] = [];
  private onChange: (value: string) => void = () => { /* */ };
  private onTouched: () => void = () => { /**/ };

  writeValue(value: string): void {
    this.valor = value ?? '';
    this.digitos = (this.valor.replace(/\D/g, '')).split('');
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  receberValor(event: Event) {
    const input = event.target as HTMLInputElement;
    const inputEvent = event as InputEvent;
    const isBackspace = inputEvent.inputType === 'deleteContentBackward';

    if (isBackspace) {
      this.digitos.pop();
    } else {
      const novoNumero = input.value.replace(/\D/g, '').slice(-1);
      if (novoNumero) {
        this.digitos.push(novoNumero);
        if (this.digitos.length > 4) {
          this.digitos.shift();
        }
      }
    }

    const padded = this.digitos.join('').padStart(4, '0');
    const horas = padded.slice(0, 2);
    const minutos = padded.slice(2, 4);
    this.valor = `${horas}:${minutos}`;
    input.value = this.valor;
    this.onChange(this.valor);
  }

  aoTocar() {
    this.tocado = true;
    this.onTouched();
  }
}
